import {
  getVersions,
  getVersionInfo,
  getDisclaimer,
  getFrontPage,
  getPopularityRanking,
  getCountriesGroups,
  getExportSources,
} from '../../../services/api.js'

export default {
  state: {
    versions: [],
    versionInfo: null,
    disclaimer: [],
    frontPage: null,
    popularityRanking: null,
    countriesGroups: null,
    exportSources: [],
  },
  getters: {
    availableCubes(state) {
      return state.versionInfo ? state.versionInfo.cubes : []
    },
    disclaimer: state => (cubeIds, countryIds, indIds) => {
      cubeIds = new Set(Array.from(cubeIds).map(id => id.replace(/\//, ':')))
      indIds = new Set(Array.from(indIds).map(id => id.replace(/\//, ':')))
      const notes = state.disclaimer
        .filter(d => cubeIds.has(d.key) || d.key.toLowerCase() === 'all')
        .concat(state.disclaimer.filter(d => countryIds.has(d.key)))
        .concat(state.disclaimer.filter(d => indIds.has(d.key)))

      if (!notes.length) {
        notes.push({
          id: null,
          value: 'No notes',
        })
      }

      return notes
    },
    disclaimerByGroupName: state => (groupName) => {
      let fixKey = (groupName + " tag group").toLowerCase()
      return state.disclaimer.filter(d => d.key.toLowerCase() === fixKey)[0]
    }
  },
  mutations: {
    parseFrontPage(state, config) {
      config.highlights &&
        config.highlights.forEach(highlight => {
          highlight.graphURL = highlight.graphURL
            ? highlight.graphURL
                .replace(/\/(explore|print|thumbnail)\//, '/embedded/')
                .replace(/\/[0-9]\//, '/' + state.versionInfo.versionId + '/')
                .replace(/https?:\/\/[^\/]+/, location.protocol + '//' + location.host)
            : null
        })
      config.sections &&
        config.sections.forEach(section => {
          section.graphURL = section.graphURL
            ? section.graphURL
                .replace(/\/(explore|print|thumbnail)\//, '/embedded/')
                .replace(/\/[0-9]\//, '/' + state.versionInfo.versionId + '/')
                .replace(/https?:\/\/[^\/]+/, location.protocol + '//' + location.host)
            : null
        })
      state.frontPage = config
    },
  },
  actions: {
    getVersions(context) {
      return getVersions().then(data => {
        context.state.versions = data
      })
    },
    getVersionInfo(context, params) {
      return getVersionInfo(params).then(data => {
        context.state.versionInfo = data
      })
    },
    getDisclaimer(context, versionId) {
      return getDisclaimer(versionId).then(data => {
        context.state.disclaimer = data
      })
    },
    getFrontPage(context, versionId) {
      return getFrontPage(versionId).then(data => {
        context.commit('parseFrontPage', data)
      })
    },
    getPopularityRanking(context, versionId) {
      return getPopularityRanking(versionId).then(data => {
        context.state.popularityRanking = data
      })
    },
    getCountriesGroups(context) {
      return getCountriesGroups().then(data => {
        context.state.countriesGroups = data
      })
    },
    getExportSources(context) {
      return getExportSources().then(data => {
        context.state.exportSources = data
      })
    },
  },
}
